import apiClient, { type RequestConfig } from './client'

export type MatterActivityKind =
  | 'processing_run'
  | 'workflow_run'
  | 'audit_summary'
  | 'approved_fact'
  | 'packet_section'
  | 'work_product'
  | 'export'
  | 'report_pack_status'
  | 'blocker'

export interface MatterActivityFeedItem {
  id: string
  occurred_at: string
  kind: MatterActivityKind
  status: string
  title: string
  summary?: string | null
  source_type: string
  source_id?: string | null
  actor?: string | null
  matter_id: string
  requires_review: boolean
  citation_count: number
  artifact_count: number
  audit_ref?: string | null
  route?: string | null
}

export interface MatterActivityFeedResponse {
  matter_id: string
  items: MatterActivityFeedItem[]
  next_cursor?: string | null
  total: number
}

export interface MatterActivityFeedQuery {
  limit?: number
  cursor?: string | null
}

export const matterActivityApi = {
  async list(
    matterId: string,
    query?: MatterActivityFeedQuery,
    config?: RequestConfig
  ): Promise<MatterActivityFeedResponse> {
    const { data } = await apiClient.get<MatterActivityFeedResponse>(
      `/matters/${matterId}/activity-feed`,
      {
        ...config,
        params: {
          limit: query?.limit,
          cursor: query?.cursor ?? undefined,
        },
      }
    )
    return data
  },
}

export default matterActivityApi
